<template>
  <div class="container">
    <h1>Oooops... not found. This is a 404</h1>
  </div>
</template>
